export default __webpack_public_path__ + "static/media/square_foot_icon.edf3b1bc.svg";